import React, { useState, useContext, useEffect } from "react";
import EditForm1 from "./EditForm1";
import EditForm2 from "./EditForm2";
import EditForm3 from "./EditForm3";
import EditForm4 from "./EditForm4";
import EditForm5 from "./EditForm5";
import EditForm6 from "./EditForm6";
import EditForm7 from "./EditForm7";

import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

function EditProfile() {
  const [step, setStep] = useState(1);
  const [profile_id, setProfileId] = useState("");  
  const { language } = useContext(LanguageContext);


  const [formData, setFormData] = useState({
    registeredBy: "",
    name: "",
    gender: "",
    dobDay: "",
    dobMonth: "",
    dobYear: "",
    birthHour: "",
    birthMinute: "",
    birthAmPm: "",
    birthPlace: "",
    maritalStatus: "",
    mobile: "",
    alternateMobile: "",
  });

  const [formData2, setFormData2] = useState({
    profileCategory: "",
    education: "",
    password: "",
    bloodGroup: "",
    jobDescription: "",
    monthlyIncome: "",
    workPlace: "",
    caste: "",
    kulam: "",
    kuladeivam: "",
    star: "",
    rasi: "",
    laknam: "",
    height: "",
    weight: "",
    colour: "",
    BodyType: "",
    jathagam: "",
  });

  const [formData3, setFormData3] = useState({
    fatherName: "",
    motherName: "",
    fatherJob: "",
    motherJob: "",
    fatherNative: "",
    motherNative: "",
    siblings: "",
    property: "",
    address: "",
    expectation: "",
  });

  const [formData4, setFormData4] = useState({
    country: "",
    state: "",
    district: "",
    livingPlace: "",
    currentlivingplace:""
  });

  const [formData5, setFormData5] = useState({
    profilePhoto1: "",
    profilePhoto2: "",
    horoscopePhoto: "",
  });

  const [formData6, setFormData6] = useState({
    planet: "",
    Year: "",
    Month: "",
    Day: "",
  });

  const [RasiChart, setRasiChart] = useState({
    r1: "", r2: "", r3: "", r4: "", r5: "", r6: "",
    r7: "", r8: "", r9: "", r10: "", r11: "", r12: ""
  });

  const [AmsamChart, setAmsamChart] = useState({
    a1: "", a2: "", a3: "", a4: "", a5: "", a6: "",
    a7: "", a8: "", a9: "", a10: "", a11: "", a12: ""
  });

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    axios.get('https://kovaikongunadumatrimony.com/kkm_backend/public/api/myprofile', {
      headers: headers
    }).then(response => {
      console.log("im api res", response.data.profile_data.mother_job_description)
setProfileId(response.data.profile_data.profile_id)
      const profileData = response.data.profile_data;
      const rasiChart = response.data.rasi_chart;
      const AmsamChart = response.data.amsam_chart
      const birthData = response.data.profile_data.birth_date;
      const splitData = birthData.split("-");

      const BirthTime = response.data.profile_data.birth_time;
      const SplitHour = BirthTime.split(" ");
      const MinuteSplit = SplitHour[0].split(":");


      setFormData({
        registeredBy: profileData.register_by,
        name: profileData.name,
        gender: profileData.gender,
        dobDay: splitData[0],
        dobMonth: splitData[1],
        dobYear: splitData[2],
        birthHour: MinuteSplit[0],
        birthMinute: MinuteSplit[1],
        birthAmPm: SplitHour[1],
        birthPlace: profileData.birth_place,
        maritalStatus: profileData.martial_status,
        mobile: profileData.mobile_number,
        alternateMobile: profileData.alternative_number,
      })
      setFormData2({
        profileCategory: profileData.profile_category,
        education: profileData.education,
        bloodGroup: profileData.blood_group,
        jobDescription: profileData.job_description,
        monthlyIncome: profileData.monthly_income,
        workPlace: profileData.work_place,
        caste: profileData.caste,
        kulam: profileData.kulam,
        kuladeivam: profileData.kula_deivam,
        star: profileData.star,
        rasi: profileData.rasi,
        laknam: profileData.laknam,
        height: profileData.height.split(" ")[0],
        weight: profileData.weight.split(" ")[0],
        colour: profileData.color,
        BodyType: profileData.body_type,
        jathagam: profileData.jathagam,
      })
      setFormData5({
        profilePhoto1: profileData.profile_photo_1,
        profilePhoto2: profileData.profile_photo_2,
        horoscopePhoto: profileData.horoscope_photo,
      });
      setFormData3({
        fatherName: profileData.father_name,
        motherName: profileData.mother_name,
        fatherJob: profileData.father_job_description,
        motherJob: profileData.mother_job_description,
        fatherNative: profileData.father_native,
        motherNative: profileData.mother_native,
        siblings: profileData.siblings,
        property: profileData.property_details,
        address: profileData.address,
        expectation: profileData.expectation,
      });
      setFormData4({
        currentlivingplace: profileData.current_living_place,
        livingPlace: profileData.living_place,
      })
      setFormData6({
        planet: profileData.dhisaiiruppu_planet,
        Year: profileData.dasa_year,
        Month: profileData.dhasa_month,
        Day: profileData.dhasa_date,
      });
      setRasiChart({
        "r1": rasiChart.r1,
        "r2": rasiChart.r2,
        "r3": rasiChart.r3,
        "r4": rasiChart.r4,
        "r5": rasiChart.r5,
        "r6": rasiChart.r6,
        "r7": rasiChart.r7,
        "r8": rasiChart.r8,
        "r9": rasiChart.r9,
        "r10": rasiChart.r10,
        "r11": rasiChart.r11,
        "r12": rasiChart.r12
      })
      setAmsamChart({
        "a1": AmsamChart.a1,
        "a2": AmsamChart.a2,
        "a3": AmsamChart.a3,
        "a4": AmsamChart.a4,
        "a5": AmsamChart.a5,
        "a6": AmsamChart.a6,
        "a7": AmsamChart.a7,
        "a8": AmsamChart.a8,
        "a9": AmsamChart.a9,
        "a10": AmsamChart.a10,
        "a11": AmsamChart.a11,
        "a12": AmsamChart.a12
      })
    });

  }, []);

  const renderFormStep = () => {

    if (step === 7) {
      return (
        <EditForm7
          formData={formData6}
          formData2={formData2}
          formData3={formData3}
          formData4={formData4}
          formData5={formData5}
          FirstFormData={formData}
          setFormData={setFormData6}
          RasiChart={RasiChart}
          setRasiChart={setRasiChart}
          AmsamChart={AmsamChart}
          setAmsamChart={setAmsamChart}
          step={step}
          setStep={setStep}
          profile_id={profile_id}
        />
      );
    }

    if (language) {
      if (step === 1) return <EditForm1 formData={formData} setFormData={setFormData} step={step} setStep={setStep} />;
      if (step === 2) return <EditForm2 formData={formData2} setFormData={setFormData2} step={step} setStep={setStep} />;
      if (step === 3) return <EditForm3 formData={formData3} setFormData={setFormData3} step={step} setStep={setStep} />;
      if (step === 4) return <EditForm4 formData={formData4} setFormData={setFormData4} step={step} setStep={setStep} />;
      if (step === 5) return <EditForm5 formData={formData5} setFormData={setFormData5} step={step} setStep={setStep} />;
      if (step === 6) return <EditForm6 formData={formData6} setFormData={setFormData6} step={step} setStep={setStep} />;
    }
    return null;
  };
  return <>
    {renderFormStep()}
  </>;
}

export default EditProfile;
